import { Pipe, PipeTransform } from '@angular/core';
import { TranslationService } from '@spartacus/core';

@Pipe({
    name: 'updateValue',
    standalone: false
})
export class updateValuePipe implements PipeTransform {
    constructor(private trser: TranslationService) { }
    transform(message: any): string {
        if (!message.message) {
            return '';
        }
        return this.translate(message);

    }

    private translate(text: any): string {
        let retext;
        this.trser.translate(text.message).subscribe((x) => {
            retext = x.replace('{0}', text.errorValue1).replace('{1}', text.errorValue2).replace('{2}', text.errorValue3).replace('{3}', text.errorValue4);
        });
        return retext;

    }

}
